<template>
  <span :class="`badge ${badgeClass}`">{{ displayText }}</span>
</template>

<script>
import { WARRANTY_RECEPTION_STATUS_NAME } from '@/utils/enum-name';
import { WARRANTY_RECEPTION_STATUS } from '@/utils/enum';

const STATUS_BADGE_CLASS = {
  [WARRANTY_RECEPTION_STATUS.RECEIVING]: 'badge-warning',
  [WARRANTY_RECEPTION_STATUS.REPAIRING]: 'badge-info',
  [WARRANTY_RECEPTION_STATUS.REPAIRED]: 'badge-primary',
  [WARRANTY_RECEPTION_STATUS.COMPLETED]: 'badge-secondary',
  [WARRANTY_RECEPTION_STATUS.RETURNED]: 'badge-success',
  [WARRANTY_RECEPTION_STATUS.REJECTED]: 'badge-danger',
};

export default {
  name: 'WarrantyStatusBadge',
  props: {
    status: {
      type: String,
      default: null,
    },
    statusName: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeClass() {
      return STATUS_BADGE_CLASS[this.status] || 'badge-secondary';
    },
    displayText() {
      return (
        this.statusName ||
        (this.status && WARRANTY_RECEPTION_STATUS_NAME[this.status]) ||
        this.status ||
        '-'
      );
    },
  },
};
</script>
